import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';

interface ConflictingTag {
  tagKey: string;
  tagLabel: string;
  allowRules: { id: string; ruleLabel: string }[];
  denyRules: { id: string; ruleLabel: string }[];
}

interface RuleConflictAlertProps {
  conflicts: ConflictingTag[];
}

export function RuleConflictAlert({ conflicts }: RuleConflictAlertProps) {
  if (conflicts.length === 0) return null;

  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Rule Conflicts Detected</AlertTitle>
      <AlertDescription className="space-y-3 mt-2">
        <p className="text-sm">
          The following tags have both ALLOW and DENY rules configured. DENY rules take precedence
          over ALLOW rules during evaluation.
        </p>
        <div className="space-y-2">
          {conflicts.map((conflict) => (
            <div key={conflict.tagKey} className="bg-white/50 p-3 rounded-md space-y-1">
              <p className="font-medium text-sm">{conflict.tagLabel}</p>
              <div className="flex flex-wrap gap-2 text-xs">
                <div className="flex items-center gap-1">
                  <Badge variant="default" className="h-5">
                    ALLOW
                  </Badge>
                  <span className="text-gray-600">
                    {conflict.allowRules.map((r) => r.ruleLabel).join(', ')}
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <Badge variant="destructive" className="h-5">
                    DENY
                  </Badge>
                  <span className="text-gray-600">
                    {conflict.denyRules.map((r) => r.ruleLabel).join(', ')}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </AlertDescription>
    </Alert>
  );
}
